import classNames from 'classnames';

import CloseIcon from '../../assets/icons/close.svg?react';
import { Dialog, Transition } from '@headlessui/react';
import { FC, Fragment, PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  isOpen: boolean;
  panelClassName?: string;
  backdropClassName?: string;
  showCloseButton?: boolean;
  onClose(): void;
};

export const Modal: FC<Props> = ({
  backdropClassName,
  children,
  panelClassName,
  isOpen,
  onClose,
  showCloseButton = true,
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      {/* Анимация закрытия Headless UI застревала, если в том же обновлении
          менялось состояние родителя (например при выборе препарата): диалог
          оставался на экране и перехватывал клики. Поэтому закрытое состояние
          гасим сами — !isOpen делает содержимое невидимым и «сквозным». */}
      <Dialog
        as="div"
        className={classNames(
          'relative z-10',
          !isOpen && 'pointer-events-none opacity-0',
        )}
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={classNames(
              'fixed inset-0',
              backdropClassName ?? 'bg-brand-1/70',
            )}
          />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex h-full min-h-full items-center justify-center text-center md:h-auto md:p-[20px]">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={classNames(
                  // md:max-h — на десктопе панель центрируется, и длинный список
                  // (например каталог препаратов) вылезал за экран сверху и снизу:
                  // края были недоступны. С ограничением по высоте панель
                  // прокручивается внутри себя, крестик остаётся на месте.
                  'relative w-full h-full md:h-auto md:max-h-[calc(100vh-40px)] max-w-[800px] overflow-y-auto overscroll-contain md:rounded-[20px] bg-white text-left align-middle transition-all',
                  panelClassName,
                )}
              >
                {showCloseButton ? (
                  <div className="pointer-events-none sticky top-0 z-10 h-0">
                    <button
                      className="pointer-events-auto absolute right-[24px] top-[24px] flex size-[24px] items-center justify-center transition-all"
                      onClick={onClose}
                      type="button"
                    >
                      <CloseIcon />
                    </button>
                  </div>
                ) : null}
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
